import { AppTile, AppTilesGridContainer, onTileClick } from '@atlassian/mpac-app-tile';
import { mapResponsiveBreakpointToScreenSize, PartialOutageError, useResponsiveBreakpoint } from '@atlassian/mpac-primitives';
import { MarketplaceStoreHomePageHighlightedSectionVariation } from '@atlassian/mpac-types/graphql-gateway-types';
import { useEnvironment, useHostUrl, useSource } from '@atlassian/mpac-utils';
import React from 'react';
import { SectionWrapper } from '../../HomepageCommon.styles';
import { useHomepageAnalytics } from '../../hooks/useHomepageAnalytics';
import { SECTIONS } from '../../hooks/useHomepageAnalytics/constants';
import { ProminentSection, ProminentSectionInfo } from '../ProminentSection';
import { RegularSection } from '../RegularSection';
import { SectionsSkeleton } from './Skeleton';
export function Sections(_ref) {
  let {
    isLoading,
    isError,
    data
  } = _ref;
  const source = useSource();
  const environment = useEnvironment();
  const hostUrl = useHostUrl();
  const {
    value: breakpoint
  } = useResponsiveBreakpoint();
  const {
    trackTileClick,
    trackHomeScreenErrorState
  } = useHomepageAnalytics();
  if (isLoading) {
    return /*#__PURE__*/React.createElement(SectionsSkeleton, null);
  }
  if (isError) {
    trackHomeScreenErrorState(SECTIONS.LISTING);
    return /*#__PURE__*/React.createElement(SectionWrapper, null, /*#__PURE__*/React.createElement(PartialOutageError, null));
  }
  const tileClickHandler = (app, title, index, hideDescription) => {
    const tileClickEventData = {
      app,
      sectionTitle: title,
      index,
      hideDescription
    };
    trackTileClick(tileClickEventData);
    onTileClick(app, source, hostUrl);
  };
  if (data) {
    const sections = data.map(section => {
      const {
        id,
        title,
        description,
        apps,
        screenSpecificProperties,
        __typename,
        navigationUrl
      } = section;
      const breakpointId = mapResponsiveBreakpointToScreenSize(breakpoint, Object.keys(screenSpecificProperties));
      const {
        appsCount,
        hideDescription
      } = screenSpecificProperties[breakpointId];
      const appsToRender = apps.slice(0, appsCount);
      if (__typename === 'MarketplaceStoreHomePageHighlightedSection' && section.highlightVariation === MarketplaceStoreHomePageHighlightedSectionVariation.Prominent) {
        return /*#__PURE__*/React.createElement(SectionWrapper, {
          key: id,
          "data-testid": "section_".concat(id)
        }, /*#__PURE__*/React.createElement(ProminentSection, null, /*#__PURE__*/React.createElement(AppTilesGridContainer, null, /*#__PURE__*/React.createElement(ProminentSectionInfo, {
          title: title,
          description: description,
          navigationUrl: navigationUrl
        }), appsToRender.map((app, index) => /*#__PURE__*/React.createElement(AppTile, {
          key: app.addonKey,
          tileData: app,
          environment: environment,
          source: source,
          hideTagline: hideDescription,
          onTileClick: () => tileClickHandler(app, title, index, hideDescription)
        })))));
      } else {
        return /*#__PURE__*/React.createElement(SectionWrapper, {
          key: id,
          "data-testid": "section_".concat(id)
        }, /*#__PURE__*/React.createElement(RegularSection, {
          title: title,
          description: description,
          navigationUrl: navigationUrl
        }, /*#__PURE__*/React.createElement(AppTilesGridContainer, null, appsToRender.map((app, index) => /*#__PURE__*/React.createElement(AppTile, {
          key: app.addonKey,
          tileData: app,
          environment: environment,
          source: source,
          hideTagline: hideDescription,
          onTileClick: () => tileClickHandler(app, title, index, hideDescription)
        })))));
      }
    });
    return /*#__PURE__*/React.createElement(React.Fragment, null, sections);
  } else {
    return null;
  }
}